export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';
export const GET_LIST_CATEGORY_SUCCESS = 'GET_LIST_CATEGORY_SUCCESS';
export const GET_LIST_CATEGORY_FAIL = 'GET_LIST_CATEGORY_FAIL';